module.exports = __webpack_public_path__ + "static/media/icon_background.948b375c.svg";